export const environment = {
  production: false,
  backendBaseUrl: 'https://www.theisa.in'
};
